"use client";

import Link from "next/link";

const PRODUCT_LINKS = [
  { label: "Comment \u00e7a marche", href: "#demo" },
  { label: "Tarifs", href: "#pricing" },
  { label: "Beta", href: "#cta" },
];

const LEGAL_LINKS = [
  { label: "CGU", href: "/cgu" },
  { label: "Confidentialit\u00e9", href: "/confidentialite" },
  { label: "Cookies", href: "/cookies" },
];

export default function FooterSection() {
  return (
    <footer
      style={{
        background: "#1a1512",
        padding: "80px 5vw 40px",
        borderRadius: '32px 32px 0 0',
        marginTop: -32,
        position: 'relative',
        zIndex: 6,
      }}
    >
      {/* Grid */}
      <div
        className="footer-grid"
        style={{
          display: "grid",
          gridTemplateColumns: "2fr 1fr 1fr",
          gap: 40,
          maxWidth: 1000,
          margin: "0 auto 60px",
        }}
      >
        {/* Brand column */}
        <div>
          <div
            style={{
              fontFamily: "var(--font-newsreader), Georgia, serif",
              fontStyle: "italic",
              fontWeight: 600,
              fontSize: 24,
              color: "var(--color-mkt-cream)",
              marginBottom: 12,
            }}
          >
            Vitrine
          </div>
          <p
            style={{
              fontSize: 14,
              color: "rgba(253,246,238,0.5)",
              lineHeight: 1.6,
              maxWidth: 280,
            }}
          >
            L&apos;IA qui transforme tes photos en annonces qui vendent.
          </p>
        </div>

        {/* Produit */}
        <div>
          <h4
            style={{
              fontSize: 13,
              fontWeight: 700,
              letterSpacing: 1,
              textTransform: "uppercase",
              marginBottom: 16,
              color: "rgba(253,246,238,0.4)",
            }}
          >
            Produit
          </h4>
          {PRODUCT_LINKS.map((link) => (
            <Link
              key={link.label}
              href={link.href}
              style={{
                display: "block",
                fontSize: 14,
                color: "rgba(253,246,238,0.6)",
                textDecoration: "none",
                marginBottom: 10,
                transition: "color 0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.color = "#FDF6EE")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = "rgba(253,246,238,0.6)")
              }
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Legal */}
        <div>
          <h4
            style={{
              fontSize: 13,
              fontWeight: 700,
              letterSpacing: 1,
              textTransform: "uppercase",
              marginBottom: 16,
              color: "rgba(253,246,238,0.4)",
            }}
          >
            {"L\u00e9gal"}
          </h4>
          {LEGAL_LINKS.map((link) => (
            <Link
              key={link.label}
              href={link.href}
              style={{
                display: "block",
                fontSize: 14,
                color: "rgba(253,246,238,0.6)",
                textDecoration: "none",
                marginBottom: 10,
                transition: "color 0.2s",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.color = "#FDF6EE")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.color = "rgba(253,246,238,0.6)")
              }
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>

      {/* Bottom bar */}
      <div
        className="footer-bottom"
        style={{
          borderTop: "1px solid rgba(253,246,238,0.08)",
          paddingTop: 32,
          maxWidth: 1000,
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: 13,
          color: "rgba(253,246,238,0.3)",
        }}
      >
        <span
          style={{
            fontFamily: "var(--font-newsreader), Georgia, serif",
            fontStyle: "italic",
            fontSize: 15,
          }}
        >
          {"Fait avec obstination \u00e0 Paris."}
        </span>
        <span>{"2026 Vitrine. Tous droits r\u00e9serv\u00e9s."}</span>
      </div>

      {/* Mobile responsive override */}
      <style>{`
        @media (max-width: 768px) {
          .footer-grid {
            grid-template-columns: 1fr !important;
            gap: 32px !important;
          }
          .footer-bottom {
            flex-direction: column !important;
            gap: 8px !important;
            text-align: center !important;
          }
        }
      `}</style>
    </footer>
  );
}
